import React, { Fragment } from "react";
import Footer from "../../components/footer";
import OurTeams from "../../components/OurTeams";
import PageTitle from "../../components/pagetitle";
import Scrollbar from "../../components/scrollbar";

const TeamsPage = () => {
  return (
    <Fragment>
      <PageTitle pageTitle={"Korean Team"} pagesub={"Team"} />
      <OurTeams />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default TeamsPage;
